import StringMask from 'string-mask'
import * as R from 'ramda'
import { cpf as cpfValidator, cnpj as cnpjValidator } from 'cpf-cnpj-validator'

const phoneFormatter = new StringMask('(00)00000-0000')
const telephoneFormatter = new StringMask('(00)0000-0000')

export const defaultPhoneFormat = value => {
  value = phoneUnmask(value)
  if (value === '') return 'Não cadastrado'
  return phoneFormatter.apply(value)
}

export const defaultTelephoneFormat = value => {
  value = phoneUnmask(value)
  if (value === '') return 'Não cadastrado'
  return telephoneFormatter.apply(value)
}

export const isEmail = (email = null) => {
  const regex = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return regex.test(email)
}

export const phoneUnmask = value => {
  if (value === undefined || value === null) return ''
  return value.replace(/\D/g, '')
}

export const validateOnlyCellphone = cellphone => {
  if (cellphone === undefined || cellphone === '') return 'Celular Obrigatório'
  if (cellphone !== undefined) {
    const celLength = phoneUnmask(cellphone).length
    if (celLength === 11) return undefined
    if (celLength !== 11) return 'Celular Inválido'
  }
}

export const validateOnlyTelephone = telephone => {
  if (telephone === undefined || telephone === '') return 'Telefone Obrigatório'
  if (telephone !== undefined) {
    const telLength = phoneUnmask(telephone).length
    if (telLength === 10) return undefined
    if (telLength !== 10) return 'Telefone Inválido'
  }
}

export const validateCellphone = (cell, tel) => {
  if (
    (cell === undefined && tel === undefined) ||
    (cell === '' && tel === '') ||
    (cell === undefined && tel === '') ||
    (cell === '' && tel === undefined)
  )
    return 'Celular ou Telefone Obrigatório'
  if (tel !== undefined) {
    if (phoneUnmask(tel).length === 10 && (cell === '' || cell === undefined))
      return undefined
  }
  if (cell !== undefined) {
    const celLength = phoneUnmask(cell).length
    if (celLength === 11) return undefined
    if ((celLength < 11 && celLength >= 1) || cell === '(__) _____-____')
      return 'Celular Inválido'
  }
}

export const validateTelephone = (cell, tel) => {
  if (
    (cell === undefined && tel === undefined) ||
    (cell === '' && tel === '') ||
    (cell === undefined && tel === '') ||
    (cell === '' && tel === undefined)
  )
    return 'Celular ou Telefone Obrigatório'
  if (!R.isNil(cell)) {
    if (phoneUnmask(cell).length === 11 && (tel === '' || tel === undefined))
      return undefined
  }
  if (!R.isNil(tel)) {
    const telLength = phoneUnmask(tel).length
    if (telLength === 10) return undefined
    if ((telLength < 10 && telLength >= 1) || tel === '(__) ____-____')
      return 'Telefone Inválido'
  }
}

export const validateEmail = (email, required = true) => {
  if (required) {
    if (email === '' || email === undefined) return 'Obrigatório'
    if (!isEmail(email)) return 'Email Inválido'
  } else {
    if (email && !isEmail(email)) return 'Email Inválido'
  }
  return undefined
}

export const formatDate = date => {
  if (date) {
    return new Date(date).toLocaleString('pt-BR').split(' ')[0]
  }
  return 'Data não informada'
}

export const formatDateTime = date => {
  if (date) {
    return new Date(date).toLocaleString('pt-BR')
  }
  return 'Data não informada'
}

export const validateCpf = cpf => {
  return cpfValidator.isValid(cpf)
}

export const validateCnpj = cnpj => {
  return cnpjValidator.isValid(cnpj)
}

export const validateCpfOrCnpj = cpfcnpj => {
  if (cpfcnpj) {
    const onlyNumbers = cpfcnpj.replace(/[^\d]/g, '')
    if (onlyNumbers.length === 11 && !validateCpf(onlyNumbers)) {
      return 'CPF Inválido'
    }
    if (onlyNumbers.length === 14 && !validateCnpj(onlyNumbers)) {
      return 'CNPJ Inválido'
    }
    if (validateCpf(onlyNumbers) || validateCnpj(onlyNumbers)) return undefined
  }
  return 'Obrigatório'
}

export const validatePlaca = value => {
  if (value) {
    const onlyChars = value.replace(/\W/g, '')
    if (onlyChars.length === 7) {
      return true
    }
  }
  return false
}

export const validateAno = ano => {
  if (!ano) return 'Obrigatório'
  if (ano < 1800) return 'Ano inválido'
  return undefined
}

export const validateCPFYup = cpf => {
  cpf = cpf.replace(/[^\d]+/g, '')
  let arr = []

  if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false

  arr = cpf.split('')

  const validator = arr
    .filter((digit, index, array) => index >= array.length - 2 && digit)
    .map(el => +el)
  const toValidate = pop =>
    arr
      .filter((digit, index, array) => index < array.length - pop && digit)
      .map(el => +el)
  const rest = (count, pop) =>
    ((toValidate(pop).reduce((soma, el, i) => soma + el * (count - i), 0) *
      10) %
      11) %
    10

  return !(rest(10, 2) !== validator[0] || rest(11, 1) !== validator[1])
}
